import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey = 'numberPlaceholderText';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  numberPlaceholderText: {
    id: 'boxForms.submitter.numberField.input.numberPlaceholderText',
    description: 'Placeholder text for number field input in Submission Page',
    defaultMessage: 'Enter a number',
  },
});

export default messages;
